import { MenuItem, Select, Typography } from "@mui/material";
import { useListBillingCoupons } from "services/billing";
import { useEffect } from "react";
import { BillingCoupon } from "protogen/billing_pb";
import { couponDescription } from "../nux/member/types";
import { ChevronDown } from "lucide-react";

type Props = {
  value?: BillingCoupon;
  onUpdate: (b?: BillingCoupon) => void;
  stacked: boolean;
  disabled: boolean;
  isAdmin: boolean;
  widthPercentage: number;
  initialCouponId?: string;
};

export default ({
  value,
  onUpdate,
  stacked,
  disabled,
  isAdmin,
  widthPercentage,
  initialCouponId,
}: Props) => {
  const { request, data, loading } = useListBillingCoupons();
  const fetchCoupons = async () => {
    const resp = await request();
    if (resp && initialCouponId) {
      const match = resp.coupons.find((c) => c.id === initialCouponId);
      if (match) {
        onUpdate(match);
      }
    }
  };
  useEffect(() => {
    if (isAdmin && !disabled && !data) {
      fetchCoupons();
    }
  }, [disabled, isAdmin]);
  const options = (data?.coupons || (value ? [value] : [])).sort(
    (a, b) => a.amountCents - b.amountCents,
  );
  if (!isAdmin) {
    return null;
  }
  return (
    <Select
      label="Discount"
      margin="none"
      displayEmpty
      value={value?.id || ""}
      disabled={disabled || loading}
      onChange={(e) => {
        const val = e.target.value;
        onUpdate(options.find((c) => c?.id === val) || undefined);
      }}
      sx={{
        "& .MuiInputBase-input": {
          marginTop: "0px !important",
        },
        width: stacked ? "100%" : `calc(${widthPercentage}% - 8px)`,
        height: "60px",
      }}
      IconComponent={ChevronDown}
    >
      <MenuItem key={""} value={""}>
        Discount (optional)
      </MenuItem>
      {options.map((coupon: BillingCoupon) => (
        <MenuItem key={coupon.id} value={coupon.id}>
          <div>
            <Typography variant="subtitle1">{coupon.name}</Typography>
            <Typography variant="body2" color="textSecondary">
              {couponDescription(coupon)}
            </Typography>
          </div>
        </MenuItem>
      ))}
    </Select>
  );
};
